export const pluralize = (quantity, singular, plural) => {
    return quantity > 1 ? plural : singular
}